export default __webpack_public_path__ + "static/media/Close Up Interactive Magic.6924862b.jpg";